import React from "react";
import { Row, Col, Button } from "reactstrap";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import APLDataGrid from "../DataGrids/APLDataGrid";
import ConfirmDialog from "../Modal/ConfirmDialog";
import EditNameDialog from "../Modal/EditNameDialogModal";
import AddWorkStepModal from "../Modal/AddWorkStepModal";
import AddNewWorkStepComponentModal from "../Modal/AddNewWorkStepComponentModal";

export default function APLWorkCardTab({
  period,
  studentParticipation,
  totalWorkHoursRegistered,
  columns,
  columnExtensions,
  promtWorkComponentForDelete,
  setPromptComponentForDelete,
  workcardItemForEditName,
  setWorkcardItemForEditName,
  handleDeleteItem,
  handleChangeNameOnWorkcardItem,
  handleSetWorkcardItemForEditName,
  addNewWorkStepOpen,
  toggleAddNewWorkStepModal,
  addNewWorkStepComponentOpen,
  toggleAddNewWorkStepComponentModal,
  currentWorkStepForAddComponent,
  level,
  objId,
  intl,
}) {
  return (
    <div>
      {studentParticipation ? (
        <>
          <HeaderRowNoScroll className="pt-2 ps-4 pb-2">
            <Col>
              <h5 style={{ fontWeight: "lighter", margin: "0" }}>
                <FormattedMessage id="NumberOfHoursRegisteredPerWorkstep" />{" "}
                - {period.period.workCard.name}
              </h5>
            </Col>
          </HeaderRowNoScroll>
          <APLDataGrid
            period={period.period}
            data={studentParticipation}
            columns={columns}
            columnExtensions={columnExtensions}
            showDelete={true}
          />
          <Row className="p-3">
            <Col>
              <h5 className="lead">
                <FormattedMessage id="TotalAmountOfHours" />:{" "}
                {totalWorkHoursRegistered}
              </h5>
            </Col>
          </Row>
          <ConfirmDialog
            isOpen={promtWorkComponentForDelete !== null}
            toggle={() => setPromptComponentForDelete(null)}
            title={intl.formatMessage({ id: "AreYouSure" })}
            message={intl.formatMessage(
              { id: "IfYouDeleteWorkstepNoRegistrationsCanBeMade" },
              {
                name:
                  promtWorkComponentForDelete !== null
                    ? promtWorkComponentForDelete.name
                    : "",
              }
            )}
            onProceed={() => handleDeleteItem()}
            danger={true}
          />
          <EditNameDialog
            toggle={() => setWorkcardItemForEditName(null)}
            isOpen={workcardItemForEditName !== null}
            title={intl.formatMessage({ id: "ChangeName" })}
            defaultName={workcardItemForEditName?.name}
            onChange={(val) => handleSetWorkcardItemForEditName(val)}
            onProceed={() => handleChangeNameOnWorkcardItem()}
          />
        </>
      ) : (
        <div>
          <FormattedMessage id="NothingToShow" />
        </div>
      )}
      <Button
        outline
        className="m-2"
        color="primary"
        onClick={() => toggleAddNewWorkStepModal()}
      >
        <FormattedMessage id="AddWorkStep" />
      </Button>
      <AddWorkStepModal
        workCardId={period.period.workCard.id}
        periodId={period.period.id}
        isOpen={addNewWorkStepOpen}
        toggle={toggleAddNewWorkStepModal}
        level={level}
        objId={objId}
      />
      <AddNewWorkStepComponentModal
        workStepId={currentWorkStepForAddComponent}
        periodId={period.period.id}
        isOpen={addNewWorkStepComponentOpen}
        toggle={toggleAddNewWorkStepComponentModal}
        level={level}
        objId={objId}
      />
    </div>
  );
}

const HeaderRowNoScroll = styled(Row)`
  &::-webkit-scrollbar {
    display: none;
  }
`;
